import React, { useEffect, useState } from "react";
import {
  getCars,
  getEmergencyServices,
  submitServiceRequest,
} from "../../../Services/emergency";
import Header from "../../header";
import { ServiceLocation } from "./ServiceLocation";
import { ServiceType } from "./ServiceType";
import LocationMap from "./Map";
import Spinner from "../../Spinner/Spinner";
import { toast } from "react-hot-toast";
import { useHistory } from "routerCompat";

const NewService = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [mapCordination, setMapCordination] = useState();
  const [activeType, setActiveType] = useState(null);
  const [cars, setCars] = useState(null);
  const [chosenCar, setChosenCar] = useState(null);
  const [typesData, setTypesData] = useState();
  const [subServices, setSubServices] = useState();
  const [chosenSubService, setChosenSubService] = useState();
  const [whereAbout, setWhereAbout] = useState();

  const handleShowmap = (condition) => {
    setShowMap(condition);
  };
  const changeMap = (latlng) => {
    setMapCordination(latlng);
  };
  const typeHandler = (id, subServices) => {
    setActiveType(id);
    if (subServices) {
      setSubServices(subServices);
    } else {
      setSubServices(null);
    }
  };
  const getLocationHandler = (loc) => {
    setWhereAbout(loc);
  };
  const carHandler = (id) => {
    setChosenCar(id);
  };
  useEffect(() => {
    getCars().then((res) => {
      setCars(res.data.data);
      getEmergencyServices().then((res) => {
        setTypesData(res.data.data);
        setLoading(false);
      });
    });
  }, []);
  const subServiceHandler = (id) => {
    setChosenSubService(id);
  };
  const submitRequest = () => {
    setSubmitLoading(true);
    const data = {
      customer_car_id: chosenCar,
      latitude: mapCordination?.lat,
      longitude: mapCordination?.lng,
      services: chosenSubService || activeType,
      address: whereAbout,
    };
    submitServiceRequest(data).then((res) => {
      toast("درخواست شما ثبت شد");
      setSubmitLoading(false);
      history.push("/emergency");
    });
  };
  return showMap ? (
    <LocationMap handleShowmap={handleShowmap} changeMap={changeMap} />
  ) : (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <Header showSearchBar={true} title="درخواست خدمت جدید" />
          <div className="newServiceWrapper">
            <ServiceType
              activeType={activeType}
              typeHandler={typeHandler}
              typesData={typesData}
              loading={loading}
              subServices={subServices}
              subServiceHandler={subServiceHandler}
              chosenSubService={chosenSubService}
              carHandler={carHandler}
              cars={cars}
              chosenCar={chosenCar}
            />
            <ServiceLocation
              getLocationHandler={getLocationHandler}
              handleShowmap={handleShowmap}
              changeMap={changeMap}
              showMap={showMap}
              submitRequest={submitRequest}
              submitLoading={submitLoading}
              whereAbout={whereAbout}
            />
          </div>
        </>
      )}
    </>
  );
};

export default NewService;
